module.exports = __webpack_public_path__ + "images/emoji/city_sunset.6c49995f0f1f79d22c77.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/city_sunset.png
// module id = TxZz
// module chunks = 13